import { MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import { SliderFilterConfig } from '@alltrails/denali/components/FilterBar';
import { Slider } from '@alltrails/denali/components/Slider';
import PaidFeatureBadge from '@alltrails/denali/components/SubscriptionBadge/PaidFeatureBadge';
import styles from './DistanceAwayFilterMobilePopup.module.scss';

type DistanceAwayFilterMobilePopupProps = {
  filterConfig: SliderFilterConfig;
  onClose: () => void;
};

const DistanceAwayFilterMobilePopup = ({ filterConfig, onClose }: DistanceAwayFilterMobilePopupProps) => {
  return (
    <div className={styles.container}>
      <Slider
        {...filterConfig.slider}
        className={styles.slider}
        label={
          <span className={styles.labelContainer}>
            <PaidFeatureBadge featureTier="plus" size="sm" variant="icon" />
            {filterConfig.slider.label}
          </span>
        }
        headerValueTextVariant="text100"
        labelTextVariant="text200bold"
      />
      <div className={styles.footer}>
        <Button onClick={onClose} size="sm" text={<FormattedMessage defaultMessage="Close" />} width="full" variant="ghost" />
        {filterConfig.onApplyClick && (
          <Button
            onClick={() => {
              filterConfig.onApplyClick?.();
              onClose();
            }}
            size="sm"
            text={<FormattedMessage defaultMessage="Apply" />}
            width="full"
            variant="ghost"
          />
        )}
        {filterConfig.filterChip.onClear && (
          <Button
            onClick={e => {
              filterConfig.filterChip.onClear?.(e as MouseEvent<HTMLButtonElement>);
              onClose();
            }}
            size="sm"
            text={<FormattedMessage defaultMessage="Clear" />}
            width="full"
            variant="ghost"
          />
        )}
      </div>
    </div>
  );
};

export default DistanceAwayFilterMobilePopup;
